import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "./i18n/config";

if (process.env.REACT_SENTRY_DNS) {
  Sentry.init({
    dsn: process.env.REACT_SENTRY_DNS,
    sampleRate: 0.25,
    ignoreErrors: ["ResizeObserver loop limit exceeded"],
  });
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
